/**
 * AI 资源管理服务
 */

import { apiClient } from '../config/netConfig';
import type { AiResource, ApiResponse } from '../types';

export const aiResourceService = {
  /**
   * 获取所有资源
   */
  async getAllResources(params?: {
    enabled?: boolean;
    provider?: string;
    tag?: string;
    modelTier?: string;
  }): Promise<AiResource[]> {
    const response = await apiClient.get<ApiResponse<AiResource[]>>(
      '/api/ai/resources',
      { params }
    );
    return response.data.data;
  },

  /**
   * 获取单个资源
   */
  async getResourceById(id: string): Promise<AiResource> {
    const response = await apiClient.get<ApiResponse<AiResource>>(
      `/api/ai/resources/${id}`
    );
    return response.data.data;
  },

  /**
   * 创建资源
   */
  async createResource(data: Partial<AiResource>): Promise<AiResource> {
    const response = await apiClient.post<ApiResponse<AiResource>>(
      '/api/ai/resources',
      data
    );
    return response.data.data;
  },

  /**
   * 更新资源
   */
  async updateResource(
    id: string,
    data: Partial<AiResource>
  ): Promise<AiResource> {
    const response = await apiClient.put<ApiResponse<AiResource>>(
      `/api/ai/resources/${id}`,
      data
    );
    return response.data.data;
  },

  /**
   * 删除资源
   */
  async deleteResource(id: string): Promise<void> {
    await apiClient.delete(`/api/ai/resources/${id}`);
  },

  /**
   * 测试资源是否可用
   */
  async testResource(id: string): Promise<{
    success: boolean;
    message: string;
    response?: string;
    error?: string;
    details?: any;
    resource?: any;
  }> {
    const response = await apiClient.post<ApiResponse<{
      success: boolean;
      message: string;
      response?: string;
      error?: string;
      details?: any;
      resource?: any;
    }>>(`/api/ai/resources/${id}/test`);
    return response.data.data;
  },
};
